import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';
import { FILTER_COLOR } from './filter-colors';
import { BOOLEAN_EXCLUDE_PREFIX } from '../helpers/filter-none';

const DUPLICATE_OPTIONS = ['duplicate_email', 'duplicate_phone'];

export const leadDuplicatesFilterConfig = createSimpleFilterConfig({
  facetName: 'duplicates',
  color: FILTER_COLOR.purple,
  withNoneOption: false,
  booleanValues: true,
  options: [
    ...DUPLICATE_OPTIONS.map((d) => ({
      label: formatTextForDisplay(d),
      value: d,
    })),
    {
      label: 'Exclude duplicates - Email',
      value: `${BOOLEAN_EXCLUDE_PREFIX}duplicate_email`,
    },
    {
      label: 'Exclude duplicates - Phone number',
      value: `${BOOLEAN_EXCLUDE_PREFIX}duplicate_phone`,
    },
  ],
});
